<div class="mb-4 flex h-9 items-start space-x-5 text-xs">
  <div class="flex items-center space-x-2">
    <span class="font-bold">Vendor Contract</span>
    <aux-vendor-dropdown
      [vendors]="(organizationQuery.allVendors$ | async)!"
      [formControl]="selectedVendor"
      (onChange)="onVendorSelected($event)"
    />
  </div>
  <div class="h-9 border-r"></div>

  @if ((loading$ | async) === true) {
    <div class="flex w-full items-center justify-center">
      <div class="spinner m-auto h-9 w-9 border-4"></div>
    </div>
  }

  @if ((loading$ | async) === false) {
    @if (budgetVersionList$ | async; as fromList) {
      <div class="flex items-center space-x-2">
        <span class="font-bold">Compare</span>
        <ng-select
          class="w-56 text-sm"
          [clearable]="false"
          [formControl]="selectedFrom"
          [items]="fromList"
          [searchable]="false"
        >
          <ng-template let-item="item" ng-label-tmp>{{ item.budget_name }}</ng-template>
          <ng-template let-item="item" ng-option-tmp>
            <div class="flex flex-col p-1">
              <div class="font-bold text-aux-blue">{{ item.budget_name }}</div>
              <div>Date Uploaded: {{ item.create_date }}</div>
              <div>Type: {{ item.budget_type }}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    }
    @if (budgetVersionToList$ | async; as toList) {
      <div class="flex items-center space-x-2">
        <span class="font-bold">to</span>
        <ng-select
          class="w-56 text-sm"
          [clearable]="false"
          [formControl]="selectedTo"
          [items]="toList"
          [searchable]="false"
        >
          <ng-template let-item="item" ng-label-tmp>{{ item.budget_name }}</ng-template>
          <ng-template let-item="item" ng-option-tmp>
            <div class="flex flex-col p-1">
              <div class="font-bold text-aux-blue">{{ item.budget_name }}</div>
              <div>Date Uploaded: {{ item.create_date }}</div>
              <div>Type: {{ item.budget_type }}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    }
    <div class="flex items-center space-x-2">
      <button
        class="btn--primary"
        [disabled]="!(selectedTo.value && selectedFrom.value)"
        (click)="compareBudget()"
      >
        <aux-icon name="Files" class="mr-2" />
        Compare
      </button>
    </div>
  }
</div>
<div class="flex h-1 w-full flex-col border-b"></div>

@if (showAnalyticsSection$ | async) {
  <div>
    <div class="mb-12 mt-8 grid grid-cols-4 gap-7.5">
      <div class="grid grid-cols-2 rounded border p-4">
        <div class="flex flex-col justify-center border-r">
          <div class="font-bold">
            Delta to Baseline
            <br />
            Vendor Budget ({{ currencySymbol }})
          </div>
        </div>
        <div class="flex items-center justify-center pl-5 text-lg font-bold tabular-nums">
          {{ totals.variance_total_cost_AC }}
          <br />
          {{ totals.variance_percentage_AC }}
        </div>
      </div>
      <div class="relative col-span-2 grid grid-cols-4 rounded border p-4">
        <div class="flex items-center border-r font-bold">
          Delta by
          <br />
          Cost Type
        </div>
        @if (false) {
          <div class="col-span-3 flex items-center justify-center">
            <div class="spinner m-auto border-4"></div>
          </div>
        }
        <ng-container>
          <div class="col-span-3 flex flex-col justify-between pl-5 tabular-nums">
            <div class="flex h-6 w-full text-xs font-bold text-white">
              <!-- [ngClass]="{ 'rounded-r': 52 === 100 }" -->
              <div
                class="rounded-l bg-aux-blue px-2 py-1 text-center"
                [ngStyle]="{ flexGrow: totals.services_total_percent_AC }"
              >
                {{ totals.services_total_percent_AC_Formatted }}
              </div>
              <!-- [ngClass]="{ rounded: 32 === 100 }" -->
              <div
                class="bg-aux-green px-2 py-1 text-center"
                [ngStyle]="{ flexGrow: totals.investigator_total_percent_AC }"
              >
                {{ totals.investigator_total_percent_AC_Formatted }}
              </div>
              <!-- [ngClass]="{ 'rounded-l': 16 === 100 }" -->
              <div
                class="rounded-r bg-aux-blue-light px-2 py-1 text-center"
                [ngStyle]="{ flexGrow: totals.pass_through_total_percent_AC }"
              >
                {{ totals.pass_through_total_percent_AC_Formatted }}
              </div>
            </div>
            <div class="mt-2 grid grid-cols-3">
              <div>
                <div class="mb-2 flex items-center">
                  <div class="mr-2 h-4 w-4 rounded-full bg-aux-blue"></div>
                  <div class="text-xs">Services</div>
                </div>
                <div class="text-sm font-bold">{{ totals.services_total_AC }}</div>
              </div>
              <div>
                <div class="mb-2 flex items-center">
                  <div class="mr-2 h-4 w-4 rounded-full bg-aux-green"></div>
                  <div class="text-xs">Investigator</div>
                </div>
                <div class="text-sm font-bold">{{ totals.investigator_total_AC }}</div>
              </div>
              <div>
                <div class="mb-2 flex items-center">
                  <div class="mr-2 h-4 w-4 rounded-full bg-aux-blue-light"></div>
                  <div class="text-xs">Pass-through</div>
                </div>
                <div class="text-sm font-bold">{{ totals.pass_through_total_AC }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="relative grid grid-cols-2 rounded border p-4">
        <div class="flex flex-col justify-center border-r">
          <div class="font-bold">Top Category Delta</div>
          <div class="flex items-center text-sm font-medium">
            Category
            <br />
            Total {{ currencySymbol }}
          </div>
        </div>
        <div class="flex items-center justify-center pl-5 text-lg font-bold tabular-nums">
          {{ totals.category_type_AC }}
          <br />
          {{ totals.category_amount_AC }}
        </div>
      </div>
    </div>
  </div>
}

<div class="mb-4 flex justify-between">
  <aux-checkbox
    id="hide_unchanged"
    class="mt-3 text-sm"
    (customChange)="compare.hideUnchangedActivities($event)"
  >
    Hide Unchanged
  </aux-checkbox>
  <aux-export-excel-button
    #excelExport
    [gridAPI]="compare.gridAPI"
    [excelOptions]="compare.excelOptions"
    [ignoreColsId]="['group1', 'group2', 'group3', 'group4', 'group5', 'changed', 'vendor_name']"
    [getDynamicExcelParamsCallback]="
      compare.getDynamicExcelParamsCallback(excelExport.getDashboardIDs())
    "
    pendoTag="compare-new-excel-export-button"
  />
</div>

<div class="mb-4">
  <aux-compare-budget
    #compare
    [fromBudgetVersion]="fromBudgetVersion$ | async"
    [toBudgetVersion]="toBudgetVersion$ | async"
    (budgetData)="onBudgetData($event)"
  />
</div>
